export const getSortedRandomDigitsList = (_data: any) => {
  const list = _data[Math.floor(Math.random() * _data.length)];
  return list.value
    .split(',')
    .sort((a: string, b: string) => a.length - b.length);
};

export const getUpdatedEnabledSequencesList = (
  sortedRandomDigitsList: string[],
  numberOfIndicesToEnable: number,
): string[] => {
  return sortedRandomDigitsList.slice(0, numberOfIndicesToEnable);
};

// assumes there are an even number of strings to ensure there are pairs of strings with equal length when sorted
export const oneOfLongestLengthIsCorrect = (digitsBackwards: any): boolean => {
  if (!digitsBackwards || !digitsBackwards?.sequencesRecalled) {
    return false;
  }

  const keys: string[] = Object.keys(digitsBackwards?.sequencesRecalled);
  if (keys.length % 2 === 0) {
    const sortedKeys: string[] = keys.sort(
      // sort length descending
      (a: string, b: string) => b.length - a.length,
    );
    return (
      digitsBackwards?.sequencesRecalled[sortedKeys[0]] === 'Correct' ||
      digitsBackwards?.sequencesRecalled[sortedKeys[1]] === 'Correct'
    );
  }

  return false;
};

export const roundDownToNearestEvenNumber = (num: number): number => {
  return Math.floor(num / 2) * 2;
};

export const roundUpToNearestEvenNumber = (num: number): number => {
  return Math.ceil(num / 2) * 2;
};
